export interface SaveData {
  checkpointId: string | null;
  checkpointX: number;
  checkpointY: number;
  coins: number;
  gems: number;
  secretsFound: string[];
  playTimeSeconds: number;
  levelCompleted: boolean;
}

export class SaveManager {
  private static readonly SAVE_KEY = 'FORGOTTEN_RUINS_SAVE_V1';

  public static getInitialSave(): SaveData {
    return {
      checkpointId: null,
      checkpointX: 100,
      checkpointY: 450,
      coins: 0,
      gems: 0,
      secretsFound: [],
      playTimeSeconds: 0,
      levelCompleted: false,
    };
  }

  public static loadSave(): SaveData {
    try {
      const raw = localStorage.getItem(this.SAVE_KEY);
      if (raw) {
        return JSON.parse(raw);
      }
    } catch (e) {
      console.warn('Failed to load save data from localStorage:', e);
    }
    return this.getInitialSave();
  }

  public static saveProgress(data: Partial<SaveData>): SaveData {
    const current = this.loadSave();
    const updated = { ...current, ...data };
    try {
      localStorage.setItem(this.SAVE_KEY, JSON.stringify(updated));
    } catch (e) {
      console.error('Failed to save to localStorage:', e);
    }
    return updated;
  }

  public static resetSave(): void {
    try {
      localStorage.removeItem(this.SAVE_KEY);
    } catch (e) {
      console.error('Failed to reset save data:', e);
    }
  }
}
